export default __webpack_public_path__ + "static/media/live_placeholder.bbfafcaf.png";